export var INFO_AGENT_PROFILE_IMAGE_SMALL_SIZE = {
  xs: 40,
  sm: 48,
  lg: 52,
  xl: 56
};
export var INFO_AGENT_PROFILE_IMAGE_SMALL_MARGIN = {
  xs: 8,
  lg: 12
};
export var INFO_AGENT_PROFILE_IMAGE_MEDIUM_SIZE = {
  xs: 48,
  md: 52,
  lg: 56,
  xl: 64
};
export var INFO_AGENT_PROFILE_IMAGE_MEDIUM_MARGIN = {
  xs: 12,
  md: 16
};